
angular.module('dybProgramsOverview', ['classy', 'classy.models', 'classy-on']);
